import {RouteSectionProps} from "@solidjs/router";
import {ErrorBoundary, Suspense} from "solid-js";
import Layout from "~/components/Layout"
import ErrorPage from "~/components/error/ErrorPage";
import MemberProvider from "./context/MemberContext";
import PostHogIdentify from "~/components/posthog/PostHogIdentify";
import PostHogProvider from "~/context/PostHogContext";

export default function AppRoot(props: RouteSectionProps) {
    return (
        <ErrorBoundary fallback={(err, reset) => <ErrorPage err={err} reset={reset}/>}>
            <Suspense>
                <PostHogProvider>
                    <MemberProvider>
                        <PostHogIdentify/>
                        <Layout>
                            {props.children}
                        </Layout>
                    </MemberProvider>
                </PostHogProvider>
            </Suspense>
        </ErrorBoundary>
    )
}